<template>
    <div class="inc_right">
        <div class="listall">
            <!--整體列表-->
            <div :class="table_Class">
                <!--內容列表查無資料物件-->
                <div :class="list_Class" v-if="list.length==0">
                    <div class="hmnewword">
                        {{NotData}}
                    </div>
                </div>
                <!--內容列表物件-->
                <div v-else 
                    :class="list_Class" v-for="(item , index) in list" v-bind:key="index" >
                    <a :href="item.url">
                        <div class="memb_left">
                            <img :src="'/filestore'+item.filepath" @error="handleImgError" :alt="item.title+'成員頭像'">
                        </div>
                        <div class="memb_right">
                            <div class="membr_title">{{ getmemberData('job',index) }}</div>
                            <div class="membr_name">{{ item.title }}</div>
                            <div class="membr_mark" v-if="(PJ_ID == 'PJ20250503'||PJ_ID == 'PJ20250506') && getmemberData('fax' ,index) != '' ">{{ getmemberData('fax' ,index) + " 退休" }}</div>
                            <div class="membr_phone" v-else>{{ getmemberData('phone',index) }}</div>
                            <div class="membr_email">{{ getmemberData('email',index) }}</div>
                        </div>
                    </a>
                </div>
            </div>
            <!--頁碼-->
            <!-- TODO 動態取得頁碼-->
            <div class="twpage" v-if="list.length>0">
                <div class="navigation">
                <b-pagination
                    class="pagination light-theme simple-pagination"
                    v-model="pagination.page"
                    :total-rows="pagination.rows"
                    :per-page="pagination.perPage"
                    aria-controls="my-table"
                ></b-pagination>
                </div>
            </div> 
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return{
            //列表樣式
            table_Class:"",
            //文章項目樣式
            list_Class:"",
            //無資料時預設文字
            NotData:"",
            //列表資料
            list:[{
                title:"",
                url:"",
                onlineDate:"",
                use_org: false,
                use_red: false,
                
            }],
        };
    },
    props:["sideright", "pagination" ,"PJ_ID"],
    mounted(){
        //初始化
        this.init();
    },
    watch:{
        "sideright"(){
            //初始化
            this.init();
        },
         "sideright.list":{
            immediate: true,
            handler() {
                this.init();
            
            },
        },
    },
    methods:{
        //初始化
        init(){
            this.table_Class=this.sideright.table_Class;
            this.list_Class = this.sideright.list_Class;
            this.list = this.sideright.list;
            if(this.sideright && this.sideright.list.length == 1){
                if(this.sideright.list[0].NotData){
                    this.list = [];
                    this.NotData = '目前尚無相關資料，敬請期待！';
                }
            }
        },
        //取得資訊
        getmemberData(dataname,index){
            const data = this.list[index].content;
            const json_data = JSON.parse(data);
            return json_data[dataname];           
        },
        //若圖片載入失敗時，切換為簡易
        handleImgError(event){
            const img = event.target;
            const fallbackUrl = new URL(
                "/images/therpc_01.jpg",
                window.location.origin
            ).href;

            // 預設圖片也載入失敗時，不再重複設定，避免循環
            if (img.src === fallbackUrl) return;

            img.src = fallbackUrl;
        },
    }
}
</script>